/**
 * Convierte importes escritos en formato local o internacional a un número con
 * dos decimales. Si hay coma, se interpreta como separador decimal; los puntos
 * restantes son separadores de miles.
 *
 * Ejemplos: 10.000,05 -> 10000.05; 1500,50 -> 1500.50; 1,500.50 -> 1500.50.
 */
export const parseMoney = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Number(value.toFixed(2)) : null;
  }

  const rawValue = String(value ?? '').trim();
  if (!rawValue) return null;

  const normalizedValue = rawValue.replace(/\s/g, '').replace(/[$Bs]/gi, '');
  const hasComma = normalizedValue.includes(',');
  const hasPeriod = normalizedValue.includes('.');
  let normalizedNumber;

  if (hasComma && hasPeriod) {
    const decimalSeparator = normalizedValue.lastIndexOf(',') > normalizedValue.lastIndexOf('.') ? ',' : '.';
    const thousandsSeparator = decimalSeparator === ',' ? /\./g : /,/g;
    normalizedNumber = normalizedValue.replace(thousandsSeparator, '').replace(decimalSeparator, '.');
  } else if (hasComma) {
    normalizedNumber = normalizedValue.replace(',', '.');
  } else {
    normalizedNumber = normalizedValue;
  }

  if (!/^[+-]?\d+(?:\.\d+)?$/.test(normalizedNumber)) return null;

  const amount = Number(normalizedNumber);
  return Number.isFinite(amount) ? Number(amount.toFixed(2)) : null;
};

export const isValidMoney = (value) => parseMoney(value) !== null;
